import TLPLayout from '@/views/Layout/TLPLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

const TLP = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/TLP.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');

// tlp pages
const Documents = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Documents.vue');
const AVSOffer = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/AVSOffer.vue');
const Offers = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Offers.vue');
const Offer = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Offer.vue');
const SoftFairOffer  =  ()  => import(/* webpackChunkName:  "pages"  */ '@/views/Pages/SoftFairOffer.vue');
const NewContract = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/NewContract.vue');
const NewEvb = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/NewEvb.vue');
//const Training = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Training.vue');

let UauthPages = {
  path: '/users/sign_in',
  component: AuthLayout,
  name: 'Authentication',
  redirect: '/login',
  meta: {
    hideForAuth: true,
  },
};
let AauthPages = {
  path: '/accounts/sign_in',
  component: AuthLayout,
  name: 'Authentication',
  redirect: '/login',
  meta: {
    hideForAuth: true,
  },
};

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  redirect: '/login',
  meta: {
    hideForAuth: true
  },
  children: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      //alias: ['/users/sign_in', '/accounts/sign_in'],
    },
    //{ path: '*', component: NotFound }
  ]
};


let DocumentPages = {
  path: '/documents',
  component: TLPLayout,
  name: 'Dokumente & Downloads',
  redirect: '/documents/list',
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/documents/list',
      name: 'Dokumente',
      component: Documents,
    },
    { path: '*', component: NotFound }
  ]
};

let OfferPages = {
  path: '/offers',
  component: TLPLayout,
  name: 'Angebote',
  redirect: '/offers/list',
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/offers/list',
      name: 'Angebotsdaten',
      component: Offers
    },
    {
      path: '/offers/sfo',
      name: 'SoftFair Angebot anlegen',
      component: SoftFairOffer,
      props: true,
    },
    {
      path: '/offers/tvs',
      name: 'Angebot anlegen',
      component: AVSOffer,
      props: true,
    },

    {
      path: '/offers/:token/edit',
      name: 'Angebot bearbeiten',
      component: AVSOffer,
      //component: NewOffer,
      props: true,
    },
    {
      path: '/offers/:token/contract',
      name: 'Angebot annehmen',
      component: NewContract,
      props: true,
    },
    {
      path: '/offers/:token',
      name: 'Angebot anzeigen',
      component: Offer,
      props: true,
    },
    {
      path: '/offers/sfo/:token',
      name: 'SoftFair Angebot anzeigen',
      component: SoftFairOffer,
      props: true,
    },
    { path: '*', component: NotFound }
  ]
};

let EvbPages = {
  path: '/evbs',
  component: TLPLayout,
  name: 'EvB',
  redirect: '/evbs/new',
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/evbs/list',
      name: 'Angebotsdaten',
      component: NewEvb,
    },
    {
      path: '/evbs/new',
      name: 'EvB anfordern',
      component: NewEvb,
      props: true,
    },
    { path: '*', component: NotFound }
  ]
};

/*
let TrainingPages = {
  path: '/training',
  component: TLPLayout,
  name: 'Training',
  redirect: '/training/videos',
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/training/videos',
      name: 'Trainingsvideos',
      component: Training,
    },
    { path: '*', component: NotFound }
  ]
};
*/



const routes = [
  OfferPages,
  EvbPages,
  DocumentPages,
  authPages,
  UauthPages,
  AauthPages,
  {
    path: '/portal',
    component: TLPLayout,
    name: 'Snb layout',
    redirect: '/offers/tvs',
    //redirect: '/portal/home',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/portal/home',
        redirect: '/offers/tvs',
        name: 'Snb',
        component: TLP,
      },
      { path: '*', component: NotFound }
    ]
  },
];

export default routes;
